import { getCookie } from '@/utils/getCookie';
import { setStorage } from './storage';
import { industryTypeMap } from '@/views/industry/config';
// import { SHAREDETAILURL } from '@/api/baseURL';
// let copyPath = SHAREDETAILURL;

//科研仪器包含路由
const platMap = ['facilities', 'instrument'];
//专家映射路由
const expertMap = ['expert'];
//路由映射
const moduleMap = {
  policy: '行业政策',
  news: '行业资讯',
  paper: '前沿技术',
  patent: '重点企业',
  report: '研究报告'
};
export const handleNavigation = () => {
  // 判断是否移动端
  const clientWith = window.screen.width;
  //是否为移动端分享得地址
  let params = new URLSearchParams(window.location.search);
  let path = params.get('path');
  const id = params.get('id');
  const type = params.get('type');

  const token = getCookie();

  //分享地址示例 https://sciplatform-us-m.steel.org.cn/?path=report&id=1&type=1

  //判断是跳转移动端还是跳转pc端
  if (clientWith <= 768) {
    //是否是分享的地址
    if (path) {
      //判断是否带有地址类型 如果有地址类型 代表是行业领域 或者专家库
      if (type) {
        //  先获取其行业领域 能获取到则用 没有则用自己的  主要是做pc端分享的行业领域转换
        const industryType = industryTypeMap[type] ?? type;

        //构造跳转地址
        const navigationUrl = `details/${path}/${id}/${industryType}`;
        window.location.replace(
          `https://sciplatform-us-m.steel.org.cn/${navigationUrl}?token=${token}`
        );
      } else {
        //不带行业领域 构造跳转地址
        const navigationUrl = `details/${path}/${id}`;
        window.location.replace(
          `https://sciplatform-us-m.steel.org.cn/${navigationUrl}?token=${token}`
        );
      }
    } else {
      // 不是分享的链接
      window.location.replace(
        `https://sciplatform-us-m.steel.org.cn?token=${token}`
      );
    }
  } else {
    let navigationUrl = ``;
    //判断是否是分享地址
    if (path) {
      //地址做个转换  从移动端首页进入详情的会带有home 需要分离出来
      path = path.replace('home', '');
      //判断是否带有地址类型
      if (type) {
        //移动端专家库分享
        if (type == 'dynamic' || type == 'homeExpertDynamic') {
          //构造地址
          navigationUrl = `expert/dynamicDetail/${id}?comps=dynamic`;
        } else {
          // 交换行业领域的键值对 因为移动端过来的是值 需要用值取键
          const reversed = Object.fromEntries(
            Object.entries(industryTypeMap).map(([key, value]) => [value, key])
          );
          const industryParams = reversed[type] ?? type;
          // 保存行业类型
          // setStorage('industryParams', industryParams);
          //保存模块类型
          setStorage('title', moduleMap[path]);
          //构造地址
          navigationUrl = `industry/detail/${id}?type=${industryParams}`;
        }
      } else {
        // 不带地址类型
        if (path == 'report') {
          //构造地址
          navigationUrl = `industry/detail/${id}`;
          //保存模块类型
          setStorage('title', moduleMap[path]);
        } else if (path == 'laboratory') {
          navigationUrl = `plat/laboratory/introduction?id=${id}`;
        } else if (platMap.includes(path)) {
          navigationUrl = `plat/instrumentFacility/detail/${id}?comps=${path}`;
        } else if (expertMap.includes(path)) {
          navigationUrl = `expert/detail/${id}?comps=people`;
        }
      }
      const text = `https://sciplatform-us.steel.org.cn/#/${navigationUrl}`;
      window.location.replace(text);
    }
  }
};
